// extracted by mini-css-extract-plugin
export default {"menuDivider":"MenuDivider_menuDivider__aqkWF"};